import Cookies from 'js-cookie';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  locale: Cookies.get('locale') ? Cookies.get('locale') : 'en'
};

export default {
  state,
  getters,
  actions,
  mutations
};
